import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import SbImageService from "../../helpers/SbImageService"

class HeroFull extends Component {
  render() {
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div
          className="hero-full"
          style={{
            backgroundImage: `url("${SbImageService(blok.image.filename)}")`,
          }}
        >
          <div className="hero-full__container container">
            <div className="hero-full__content">
              <h1 className="hero-full__heading">{blok.title}</h1>
              <div className="hero-full__copy">
                {
                  unified()
                    .use(remarkParse)
                    .use(remarkRehype)
                    .use(rehypeReact, {
                      createElement: React.createElement,
                      components: remarkReactComponents,
                      Fragment: React.Fragment
                    })
                    .processSync(blok.description).result
                }
              </div>
              <div className="hero-full__btn">
                {blok.primary_cta &&
                  blok.primary_cta.map(
                    (content) =>
                      React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                        className: "btn--cta-color",
                      })
                  )}
              </div>
            </div>
          </div>
        </div>
      </SbEditable>
    )
  }
}

HeroFull.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    cta: PropTypes.arrayOf(PropTypes.object),
    primary_cta: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default HeroFull
